{
  "homepage": {
    "lt": "/",
    "en": "/",
    "ru": "/"
  },
  "account": {
    "lt": "/paskyra/",
    "en": "/account/",
    "ru": "/naznachenie/"
  },
  "contacts": {
    "lt": "/imone/kontaktai/",
    "en": "/company/contact/",
    "ru": "/kompanija/kontakty/"
  },
  "about": {
    "lt": "/imone/nostra/",
    "en": "/company/nostra/",
    "ru": "/kompanija/o-nas/"
  },
  "product-payment": {
    "lt": "/informacija-pirkejui/atsiskaitymo-budai/",
    "en": "/information/payment-methods/",
    "ru": "/informacija-pokupatelju/metody-oplaty/"
  },
  "b2b": {
    "lt": "/imone/verslo-klientams/",
    "en": "/company/for-business/",
    "ru": "/kompanija/biznesu/"
  },
  "oeko-tex": {
    "lt": "/imone/oeko-tex-standard-100-sertifikatas/",
    "en": "/company/oeko-tex-standard-100-certificate/",
    "ru": "/kompanija/oeko-tex-standard-100-sertifikat/"
  },
  "product-delivery": {
    "lt": "/informacija-pirkejui/prekiu-pristatymas/",
    "en": "/information/delivery/",
    "ru": "/informacija-pokupatelju/dostavka-tovara/"
  },
  "returns": {
    "lt": "/informacija-pirkejui/prekiu-grazinimas/",
    "en": "/information/returns/",
    "ru": "/informacija-pokupatelju/vozvrat-tovara/"
  },
  "rules": {
    "lt": "/informacija-pirkejui/taisykles/",
    "en": "/information/terms-and-conditions/",
    "ru": "/informacija-pokupatelju/pravila/"
  },
  "privacy": {
    "lt": "/informacija-pirkejui/privatumo-politika/",
    "en": "/information/privacy/",
    "ru": "/informacija-pokupatelju/konfidencialnost/"
  },
  "loyalty": {
    "lt": "/informacija-pirkejui/lojalumo-programa/",
    "en": "/information/loyalty-program/",
    "ru": "/informacija-pokupatelju/programma-lojalnosti/"
  },
  "guestbook": {
    "lt": "/imone/sveciu-knyga/",
    "en": "/company/guest-book/",
    "ru": "/kompanija/gostevaja-kniga/"
  },
  "friends": {
    "lt": "/imone/draugai/"
  },
  "info-exclusive-bedding": {
    "lt": "/informacija-exclusive-patalyne/"
  },
  "info-mako-satin-bedding": {
    "lt": "/informacija-mako-satino-patalyne/"
  },
  "info-satin-bedding": {
    "lt": "/informacija-satino-patalyne/"
  },
  "info-linen-bedding": {
    "lt": "/informacija-drobes-patalyne/"
  },
  "info-flannel-bedding": {
    "lt": "/informacija-flaneles-patalyne/"
  },
  "info-crinkled-bedding": {
    "lt": "/informacija-glamzyta-patalyne/"
  },
  "info-mixed-fiber-bedding": {
    "lt": "/informacija-misraus-pluosto-patalyne/"
  },
  "info-bamboo-towels": {
    "lt": "/informacija-bambukiniai-ranksluosciai/"
  },
  "info-towels-380": {
    "lt": "/informacija-380-gsm-ranksluosciai/"
  },
  "info-towels-550": {
    "lt": "/informacija-550-gsm-ranksluosciai/"
  },
  "info-cashmere-blankets": {
    "lt": "/informacija-pledai-su-kasmyru/"
  },
  "info-merino-wool-blankets": {
    "lt": "/informacija-merino-vilnos-pledai/"
  },
  "info-wool-blankets": {
    "lt": "/informacija-vilnoniai-pledai/"
  },
  "info-satin-sheets": {
    "lt": "/informacija-satino-paklodes/"
  },
  "info-jersey-sheets": {
    "lt": "/informacija-trikotazines-paklodes/"
  },
  "info-terry-sheets": {
    "lt": "/informacija-frotines-paklodes/"
  },
  "info-linen-sheets": {
    "lt": "/informacija-drobines-paklodes/"
  },
  "secret-discount-code": {
    "lt": "/slaptas-nuolaidos-kodas/"
  }
}
